import { render } from "./SoundButton.vue?vue&type=template&id=52c51117&scoped=true&bindings={\"muted\":\"props\",\"switchSound\":\"options\"}"
import script from "./SoundButton.vue?vue&type=script&lang=js"
export * from "./SoundButton.vue?vue&type=script&lang=js"

import "./SoundButton.vue?vue&type=style&index=0&id=52c51117&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-52c51117"

export default script